export function formatToTwoDecimals(number: number) {
  return number === null || number === undefined
    ? '-'
    : Number(number).toFixed(2);
}
